import styles from "./styles.scss";
import { Body, Heading } from "../typography";
import IconArrowForward from "../../assets/icons/icon-arrow_forward.svg";
import IconClose from "../../assets/icons/icon-close.svg";
import Avatar from "../avatar";
import {CurrentUserContext, OrganizationContext, RoomsContext} from "../../contexts";
import { useContext } from "preact/hooks";
import { getProfile } from "../../selectors";
import {getRoom} from "../../utils";
import Icon from "../Icon/Icon";
import {NavigationContext} from "../../contexts/NavigationContext";
import {GlobalContext} from "../../contexts/GlobalContext";
import Margin from "../Margin/Margin";

const getAppBarLeft = (currentRoute, navigate) => {
  switch (currentRoute.path) {
    case "/contacts":
      return <LeftButton onClick={() => navigate({ path: "/" })} />;
    case "/chat":
      return (
        <ChatLeftButton
          onClick={() => currentRoute.params.onBack ? currentRoute.params.onBack() : navigate({ path: "/" }) }
          contactInternalId={currentRoute.params.contactInternalId}
          roomId={currentRoute.params.roomId}
          broadcastList={currentRoute.params.broadcastList}
        />
      );
    default:
      break;
  }
};

const getTitle = (title, currentRoute) => {
  switch (currentRoute.path) {
    case "/video-call-lobby":
      return "Chamada de vídeo"
    case "/contacts":
      return "Selecionar contato";
    case "/chat":
      if (currentRoute.params.broadcastList && currentRoute.params.broadcastList.length > 0) {
        return "Lista de transmissão";
      }
      const organization = useContext(OrganizationContext);
      const rooms = useContext(RoomsContext);
      const currentUser = useContext(CurrentUserContext);
      const {roomId, contactInternalId, channelName} = currentRoute.params;
      const room = getRoom(rooms, roomId, contactInternalId, channelName);
      if (channelName || (room && room.type === 'channel')) {
        if (room) {
          return room.channelName;
        }
        else return 'Conectando...';
      }
      else {
        if (room && room.usersInternalIds) {
          const otherUserInternalId = room.usersInternalIds.find(id => id !== currentUser.internalId);
          const profile = getProfile(organization, otherUserInternalId);
          return profile ? profile.name : "Mensagens";
        } else if (currentRoute.params.contactInternalId) {
          const profile = getProfile(organization, currentRoute.params.contactInternalId);
          return profile ? profile.name : "Mensagens";
        }
      }
      return '';
    case "/":
      return title;
    default:
      break;
  }
};

const AppBar = ({ onRequestClose, subtitle }) => {
  const {options} = useContext(GlobalContext);
  const rooms = useContext(RoomsContext);
  const currentUser = useContext(CurrentUserContext);
  const {route, appBarRight, navigate} = useContext(NavigationContext);

  const onRequestVideo = () => {
    const {roomId, contactInternalId, channelName} = route.params;
    const room = getRoom(rooms, roomId, contactInternalId, channelName);
    const otherUserInternalId = room.usersInternalIds.find(id => id !== currentUser.internalId);
    navigate({path: "/video-call-lobby", params: {
      ...route.params,
        contactInternalId: otherUserInternalId
    }});
  }

  return (
    <div className={styles.appbar}>
      {getAppBarLeft(route, navigate)}
      <div className={styles.main}>
        <Heading>{getTitle(options.appBarTitle, route)}</Heading>
        {route.path === "/chat" && <Body style={{ fontSize: "0.85rem", color: "#fff" }}>{subtitle}</Body>}
      </div>
      {appBarRight}
      <div className={styles.trailing}>
        {route.path === "/chat" && <Margin top={2} right={8}><Icon name="video" onClick={onRequestVideo} color="#fff" /></Margin>}
        {options.displayMode === "modal" && <IconClose
          className={styles.trailingCloseButton}
          onClick={onRequestClose}
        />}
      </div>
    </div>
  );
};

const IconArrowBackward = () => (
  <IconArrowForward
    className={styles.leftIcon}
    style={{ transform: "rotate(180deg)" }}
  />
);
const LeftButton = ({ onClick }) => (
  <a onClick={onClick} className={styles.leftButton}>
    <Icon name="arrow_backward" color={'#fff'} />
  </a>
);

const ChatLeftButton = ({ onClick, contactInternalId, roomId, channelName, broadcastList }) => {
  const organization = useContext(OrganizationContext);
  const currentUser = useContext(CurrentUserContext);
  const rooms = useContext(RoomsContext);
  let isChannel = false;

  let avatarUrl = '';
  const room = getRoom(rooms, roomId, contactInternalId);
  if (room && room.type === 'channel' || channelName)
    isChannel = true;
  if (room && room.usersInternalIds) {
    const otherUserInternalId = room.usersInternalIds.find(id => id !== currentUser.internalId);
    const profile = getProfile(organization, otherUserInternalId);
    avatarUrl = profile && profile.avatar_url;
  } else if (contactInternalId) {
    const profile = getProfile(organization, contactInternalId);
    avatarUrl = profile && profile.avatar_url;
  }

  if (broadcastList && broadcastList.length > 0) {
    return <a onClick={onClick} className={styles.avatarLeftButton}><IconArrowBackward /></a>;
  }

  return (
    isChannel ? <div/> : <a onClick={onClick} className={styles.avatarLeftButton}>
      <IconArrowBackward />
      {avatarUrl && <Avatar src={avatarUrl} style={{width: 32, height: 32}}/>}
    </a>
  );
};

export default AppBar;



// WEBPACK FOOTER //
// ./components/app-bar/index.js